/**
 * AddEmployeesButton
 */

import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useApi2call, useApi2update } from 'containers/Api2/index.js';
import AddUserModal from '../AddUserModal.jsx';
import schema from './form.js';
import messages from './messages.js';
import ImportWizard from '../ImportWizard/index.jsx';
import ConfirmSubmitAdd from './ConfirmSubmitAdd.jsx';

function AddEmployeesButton() {
  const [showOne, setShowOne] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const intl = useIntl();
  const navigate = useNavigate();
  const api2call = useApi2call();
  const api2update = useApi2update();
  const title = intl.formatMessage(messages.addEmployee);
  const columns = ['firstName', 'middleName', 'lastName', 'alias', 'group'];
  const defaultValues = { groups: [] };

  function handleSubmit(users) {
    return api2call({
      method: 'POST',
      url: 'sa/users/employee/import',
      selector: 'sa/users/employee',
      reducer: (state, action) => {
        const { list, ...values } = action.payload;
        const result = {
          ...state,
          ...values,
          list: [...list, ...state.list],
          totalCount: state.totalCount + list.length,
        };
        return result;
      },
      version: 2,
      body: { users },
      withPromise: true,
    })
      .then(() => api2update({ selector: 'sa/groups/classes', updater: (state) => state && state.clear() }));
  }

  function showConfirmSubmit(mappedData) {
    return (
      <ConfirmSubmitAdd
        users={mappedData}
        roleName="employee"
        onClose={() => setShowImport(false)}
        onSubmit={handleSubmit}
      />
    );
  }
  return (
    <>
      <DropdownButton
        variant="light"
        title={title}
        key={1}
        align="end"
        id="add-employees"
      >
        <Dropdown.Item as="button" eventkey="1" onClick={() => navigate('/admin/users/invite/employee')}><FormattedMessage {...messages.inviteEmployees} /></Dropdown.Item>
        <Dropdown.Item as="button" eventkey="2" onClick={() => setShowOne(true)}><FormattedMessage {...messages.individualEmployee} /></Dropdown.Item>
        <Dropdown.Item as="button" eventkey="3" onClick={() => setShowImport(true)}><FormattedMessage {...messages.importEmployees} /></Dropdown.Item>
      </DropdownButton>
      <AddUserModal
        show={showOne}
        title={messages.addEmployee}
        type="employee"
        schema={schema}
        defaultValues={defaultValues}
        onClose={() => setShowOne(false)}
      />
      <ImportWizard
        show={showImport}
        title={messages.importEmployees}
        template="/Template_importeren_medewerkers.xlsx"
        columns={columns}
        showConfirmSubmit={showConfirmSubmit}
        onHide={() => setShowImport(false)}
      />
    </>
  );
}

AddEmployeesButton.propTypes = {
};

export default AddEmployeesButton;
